<template lang="pug">
  .par.margin-bottom
    strong {{chave}}: &nbsp
    span {{valor}}
</template>

<script>
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    AppLabel
  },

  props: {
    chave: {
      type: String,
      required: true
    },
    valor: {
      type: String,
      required: true
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/AppPar.vue